import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import { createStructuredSelector } from 'reselect';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import { selectNotifications } from '../../store/selectors';
import { removeNotification } from '../../store/actions/notification';

const propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number,
    }),
  ).isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  onRemoveNotifcation: PropTypes.func.isRequired,
  closeSnackbar: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    dismissButton: PropTypes.string,
  }).isRequired,
};

export class Notifier extends React.Component {
  displayed = [];

  storeDisplayed = id => {
    this.displayed = [...this.displayed, id];
  };

  shouldComponentUpdate(nextProps) {
    let notExists = false;
    for (let i = 0; i < nextProps.notifications.length; i += 1) {
      // eslint-disable-next-line no-continue
      if (notExists) continue;
      notExists =
        notExists ||
        !this.props.notifications.filter(
          ({ key }) => nextProps.notifications[i].key === key,
        ).length;
    }
    return notExists;
  }

  getNotificationAction = key => {
    const { closeSnackbar, classes } = this.props;

    return (
      <IconButton
        onClick={() => {
          closeSnackbar(key);
        }}
      >
        <CloseIcon className={classes.dismissButton} />
      </IconButton>
    );
  };

  componentDidUpdate() {
    const { notifications, onRemoveNotifcation, enqueueSnackbar } = this.props;

    notifications.forEach(notification => {
      // Do nothing if snackbar is already displayed
      if (this.displayed.includes(notification.key)) return;
      // Display snackbar using notistack
      enqueueSnackbar(notification.message, {
        ...notification.options,
        action: this.getNotificationAction(notification.key),
      });
      // Keep track of snackbars that we've displayed
      this.storeDisplayed(notification.key);
      // Dispatch action to remove snackbar from redux store
      onRemoveNotifcation(notification.key);
    });
  }

  render() {
    return null;
  }
}

Notifier.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  notifications: selectNotifications(),
});

const mapDispatchToProps = dispatch => ({
  onRemoveNotifcation: key => dispatch(removeNotification(key)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(withStyles(styles)(Notifier)));
